var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scenery_options",class:{ without_scenary: _vm.wsWithoutGlobal.includes(_vm.workspaceId) },style:({
          background: ((_vm.colors.backgrounds.solidLight) + "80")
      })},[_c('span',[_vm._v(_vm._s(_vm.$t("components.scenaryOptions.scenery_options")))])])}
var staticRenderFns = []

export { render, staticRenderFns }